/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';

import { element } from 'prop-types';
import GooglePay from '../PaymentButtonBuilder/buttons/GooglePayButton/GooglePay/GooglePay';
import EligiblePaymentMethods from '../EligiblePaymentMethods/EligiblePaymentMethods';
import { getFeatureFlags, getOnePageCheckoutSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';
import { isPaymentOrReviewPage } from '../Helpers/Helper';

const EligiblePaymentMethodContainer = ({
    children,
}) => {
    const featureFlags = useSelector(getFeatureFlags) || {};
    const onePageCheckout = useSelector(getOnePageCheckoutSaleForceABTest) || {};

    const isGooglePayEnabled = featureFlags['is-google-pay-enabled'];

    const isSingleShippingPaymentEnabled = featureFlags['is-one-page-checkout-enabled'] === 'newflow'
        || (
            featureFlags['is-one-page-checkout-enabled'] === 'salesforce'
            && onePageCheckout?.campaign?.campaignResponses?.[0]?.userGroup === 'Default'
        );

    if (
        window?.location?.href
        && (
            isPaymentOrReviewPage(window.location.href)
            || (
                window?.location?.href.indexOf('/shipping/') > 0
                && isSingleShippingPaymentEnabled
            )
        )
    ) {
        return (
            <GooglePay
                featureEnabled={isGooglePayEnabled}
                render={({
                    isGooglePayLoaded,
                    isGooglePaySupported = false,
                }) => (
                    <EligiblePaymentMethods
                        isGooglePayLoaded={isGooglePayLoaded}
                        isGooglePaySupported={isGooglePaySupported}
                    >
                        { children }
                    </EligiblePaymentMethods>
                )}
            />
        );
    }

    return children;
};

EligiblePaymentMethodContainer.propTypes = {
    children: element.isRequired,
};

export default EligiblePaymentMethodContainer;
